/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionalertpendingactivationmessage4Inputs */



/**
* | output |
* | --- |
* | "Payment received, but the store hasn’t confirmed the update yet. The subscription should activate within a couple of minutes." |
*
* @param {Subscriptionalertpendingactivationmessage4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscriptionalertpendingactivationmessage4 = /** @type {((inputs?: Subscriptionalertpendingactivationmessage4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionalertpendingactivationmessage4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Payment received, but the store hasn’t confirmed the update yet. The subscription should activate within a couple of minutes.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El pago se recibió, pero la tienda todavía no ha confirmado la actualización. La suscripción debería activarse en un par de minutos.")
	return /** @type {LocalizedString} */ ("Платёж принят, но обновление от магазина ещё не дошло. Подписка должна активироваться в течение пары минут.")
});
export { subscriptionalertpendingactivationmessage4 as "subscriptionAlertPendingActivationMessage" }